import crypto from 'crypto';

import hexToUuid from 'hex-to-uuid';

import { type ChannelVariableContext, type EditorPluginAIProvider } from '../../types';

/**
 * Creates the chat channelID for use with ConvoAI/assistance-service API.
 * A stable UUID is based on URL + Agent ID + User ID + Cloud ID.
 */
type CreateChannelContext = ChannelVariableContext['rovo-agent'] & { agentId: string };
const createChannelId = (context: CreateChannelContext): string => {
	const { contentURL, agentId, cloudId, userId } = context;
	const input = `${contentURL}-${agentId}-${cloudId}-${userId}`;

	// Rifat's voodoo to replicate Java's hashing implementation
	// @see https://atlassian.slack.com/archives/C075C6PPJ01/p1716960655383639?thread_ts=1716957128.598589&cid=C075C6PPJ01
	const md5Bytes = crypto.createHash('md5').update(input).digest();
	md5Bytes[6] &= 0x0f; // clear version
	md5Bytes[6] |= 0x30; // set to version 3
	md5Bytes[8] &= 0x3f; // clear variant
	md5Bytes[8] |= 0x80; // set to IETF variant
	return hexToUuid(md5Bytes.toString('hex'));
};

export const buildChannelId = ({
	getChannelVariables,
	agentId,
}: {
	getChannelVariables: EditorPluginAIProvider['getChannelVariables'];
	agentId: string;
}) => {
	const channelVariables = getChannelVariables?.('rovo-agent');

	if (!channelVariables) {
		throw new Error('channelVariables is required for Rovo chat actions');
	}

	const channelId = createChannelId({
		...(channelVariables ?? {}),
		agentId,
	});

	return channelId;
};
